<template>
  <div
    v-if="showTermsAndConditionsModalFlag"
    class="Overlay Overlay-sup"
    data-action="close-modal"
  >
    <div class="ModalBox ModalBox--central Modal--filters sup2 ModalBox--400 terms-conditions-modal">
      <div class="ModalBox-header d-flex justify-content-between align-items-center p-4">
        <div class="Tit Tit--modal w-100">
          {{$t(`terms_conditions_title`)}}
        </div>
      </div>
      <div class="ModalBox-container position-relative pl-4 pr-4 pt-4">
        <div class="Fuell-Text text-center">
          <ul class="terms-list">
            <li
              v-for="legalDocument in legalDocuments.data"
              :key="legalDocument.id"
            >
              <a
                role="button"
                :href="legalDocument.url"
                target="_blank"
                aria-describedby="more info"
                rel=noopener
                class="read-link"
              >
                <img
                  class="icon"
                  alt="'icon-open-document-link'"
                  :src="require('@/assets/img/icons/icon-arrow-right.svg')"
                />
              </a>

              <p
                class="title"
                v-t="{path: `user_terms_${legalDocument.documentType}`}"
              ></p>
              <p
                class="description"
                v-t="{path: `user_terms_${legalDocument.documentType}_explanation`}"
              ></p>
            </li>
          </ul>
        </div>
        <div class="terms-and-conditions-input--container">
          <input
            v-model="userAcceptTerms"
            type="checkbox"
            id="userNewTerms"
          >
          <div class="terms-and-conditions-input--texts">
            <label
              for="userNewTerms"
              class="terms-and-conditions-input--text separator"
            >{{$t(`user_terms_accept_label_new`)}} </label>
            <template v-for="(legalDocument, index) in legalDocuments.data">
              <span :key="legalDocument.id">
                <span
                  v-if="index > 0 && index < legalDocuments.data.length && index + 1 < legalDocuments.data.length"
                  class="terms-and-conditions-input--text separator"
                >,</span>
                <span
                  v-else-if="index > 0 && index + 1 === legalDocuments.data.length"
                  class="terms-and-conditions-input--text separator-last"
                >{{$t('AND')}}</span>
                <a
                  class="terms-and-conditions-input--text text-primary"
                  :href="legalDocument.url"
                  target="_blank"
                  rel=noopener
                >{{$t(`user_terms_${legalDocument.documentType}`)}}</a>
              </span>
            </template>
          </div>
        </div>
      </div>
      <div class="p-3 d-flex justify-content-center">
        <button
          type="button"
          @click="acceptTerms"
          class="Fuell-Button mx-2 flex-grow-1 flex-shrink-1 text-center"
          :class="{'disabled': !userAcceptTerms, 'Button--primary': userAcceptTerms}"
          :disabled="!userAcceptTerms"
        >
          <span
            class="Fuell-Button--label"
            v-t="{ path: 'terms_conditions_accept' }"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import legalDocumentsApi from './_api'
export default {
  data () {
    return {
      showTermsAndConditionsModalFlag: false,
      userAcceptTerms: false,
      legalDocuments: []
    }
  },
  computed: {
    user () {
      return this.$store.getters['LoginStore/user']
    }
  },
  methods: {
    handleAcceptTerms () {
      this.userAcceptTerms = !this.userAcceptTerms
    },
    async acceptTerms () {
      const terms = {}
      if (this.legalDocuments?.data) {
        this.legalDocuments.data.forEach(element => {
          if (element.documentType === 'general_conditions') {
            terms.acceptedGeneralConditionsVersion = element.version
          } else if (element.documentType === 'payment_service_conditions') {
            terms.acceptedPaymentServiceConditionsVersion = element.version
          } else if (element.documentType === 'privacy_policy') {
            terms.acceptedPrivacyPolicyVersion = element.version
          } else if (element.documentType === 'service_conditions') {
            terms.acceptedServiceConditionsVersion = element.version
          }
        })
        await legalDocumentsApi.acceptTerms(this.user.id, terms).then(() => {
          this.showTermsAndConditionsModalFlag = false
        }).catch((error) => {
          console.error(error)
        })
      }
    }
  },
  async created () {
    this.legalDocuments = await legalDocumentsApi.getLegalDocuments()
    this.showTermsAndConditionsModalFlag = this.legalDocuments?.data?.length > 0
  }
}
</script>
<style lang="scss" scoped>
.terms-conditions-modal {
  .Tit {
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    color: var(--text-heading);
  }
  .ModalBox-container {
    margin-top: 24px !important;
  }
  .terms-and-conditions-input {
    &--container {
      margin-top: 32px;
      display: flex;
      align-items: center;
    }
    &--texts {
      margin-left: 8px;
    }
    &--text {
      margin: 0;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--text-body);
      &.separator {
        margin: 0 2px 0 0;
      }
      &.separator-last {
        margin: 0 2px;
      }
    }
  }
  .terms-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    text-align: left;
    margin-top: 36px;
    li {
      margin-bottom: 16px;
      position: relative;
      .title {
        font-weight: 500;
        font-size: 15px;
        line-height: 24px;
        color: var(--text-heading);
        margin-bottom: 0;
      }
      .description {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: var(--text-body);
        margin-bottom: 0;
        max-width: 286px;
      }
      .read-link {
        position: absolute;
        width: 12px;
        height: 12px;
        top: 37px;
        right: 10px;
      }
    }
  }
}
</style>
